import * as React from 'react'
import BaseEmpty, { EmptyProps as BaseProps } from 'antd/lib/empty'

export interface EmptyProps extends BaseProps {}

export const Empty = (props: EmptyProps): JSX.Element => (
  <>
    <BaseEmpty {...props} />
  </>
)
